import { render, staticRenderFns } from "./CardSchool.vue?vue&type=template&id=400174fc&"
import script from "./CardSchool.vue?vue&type=script&lang=js&"
export * from "./CardSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports